'use client'

import React from 'react'
import { useRouter } from 'next/navigation'
import styles from './styles.module.css'
import AnimatedSection from '@/components/AnimatedSection'

const Portfolio: React.FC = () => {
  const router = useRouter()

  // Функция для обработки клика по карточке
  const handleCaseClick = (caseId: number) => {
    const caseRoutes: Record<number, string> = {
      1: '/portfolio/treasury-automation',
      2: '/portfolio/materials-marketplace', 
      3: '/portfolio/multibanking',
      4: '/portfolio/partner-b2b',
      5: '/portfolio/lk-agro-b2b', // Личный кабинет в сельском хозяйстве для B2B
      6: '/portfolio/card-project' // для 6-й карточки
    }
    
    const route = caseRoutes[caseId]
    if (route) {
      router.push(route)
    }
  }

  const cases = [
    {
      id: 1,
      title: 'Автоматизация казначейства в финансовом секторе',
      description: 'Автоматизация процессов обработки трансграничных платежей',
      category: 'Финансы',
      image: '/images/portfolio/redesign/case_card_image_1.png'
    },
    {
      id: 2,
      title: 'Онлайн маркетплейс материалов',
      description: 'Платформа, объединяющая заказчиков и производителей материалов со всего мира',
      category: 'Ритейл',
      image: '/images/portfolio/redesign/case_card_image_2.png'
    },
    {
      id: 3,
      title: 'Мультибанкинг: автоматизация в финтехе',
      description: 'Сервис для автоматического распознавания банковских выписок',
      category: 'Финансы',
      image: '/images/portfolio/redesign/case_card_image_3.png'
    },
    {
      id: 4,
      title: 'B2B-платформа для оптовой торговли',
      description: 'Цифровая платформа, которая переводит ручные оптовые продажи в единый онлайн-канал с интеграцией 1С и CRM.',
      category: 'Ритейл',
      image: '/images/portfolio/redesign/case_card_image_4.png'
    },
    {
      id: 5,
      title: 'Личный кабинет в сельском хозяйстве для B2B',
      description: 'Разработка личного кабинета для агрегации заказов между производителем и фермерами',
      category: 'Промышленность',
      image: '/images/portfolio/redesign/case_card_image_5.png'
    },
    {
      id: 6,
      title: 'ИИ-решение для Kiwi Immigration на базе ChatGPT',
      description: 'Сервис для автоматической генерации сопроводительного письма с помощью ИИ в иммиграционную службу',
      category: 'Юридические услуги',
      image: '/images/portfolio/redesign/case_card_image_6.png'
    }
  ]

  return (
    <section className={styles.portfolio}>
      <div className={styles.container}>
        {/* Block heading */}
        <div className={styles.heading}>
          <div className={styles.subtitle}>
            <p className={styles.subtitleText}>
              Кейсы
            </p>
          </div>
          <div className={styles.title}>
            <h2 className={styles.titleText}>
              Реализованные проекты
            </h2>
          </div>
        </div>
        
        {/* Case cards */}
        <div className={styles.grid}>
          {cases.map((caseItem) => (
            <AnimatedSection key={caseItem.id} animation="slideUp">
            <div
              className={styles.card}
            >
              {/* Case image */}
              <div 
                className={styles.imageContainer}
                onClick={() => handleCaseClick(caseItem.id)}
              >
                <div 
                  className={styles.imageBackground}
                  style={{
                    backgroundImage: caseItem.image ? `url('${caseItem.image}')` : undefined,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                />
                {/* Category chevron */}
                <div className={styles.categoryBadge}>
                  <span className={styles.categoryText}>
                    {caseItem.category}
                  </span>
                </div>
              </div>
              
              {/* Case content */}
              <div 
                className={styles.content}
              >
                <div className={styles.textContainer}>
                  <div className={styles.titleContainer}>
                    <h3 
                      className={styles.cardTitle}
                      dangerouslySetInnerHTML={{ __html: caseItem.title }}
                    />
                  </div>
                  <div className={styles.descriptionContainer}>
                    <p 
                      className={styles.cardDescription}
                      dangerouslySetInnerHTML={{ __html: caseItem.description }}
                    />
                  </div>
                </div>
                
                <div className={styles.link}>
                  <div 
                    className={styles.linkContent}
                    onClick={() => handleCaseClick(caseItem.id)}
                  >
                    <span className={styles.linkText}>Подробнее</span>
                    <div className={styles.linkIcon}>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="#f23b67" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  )
}

Portfolio.displayName = 'Portfolio'

export default Portfolio
